import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

/**
 * Servicio de la fuente PDF del módulo Inversiones exterior (DJ 1929)
 * Encapsula las llamadas al API /api/inversiones-exterior/pdf. La revisión, la
 * edición y la validación de la carga van por el servicio común (inversionesExteriorService).
 */
class InversionesExteriorPdfService {
    /**
     * Configurar headers de autenticación
     */
    _getHeaders(token) {
        return {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
    }

    /**
     * Configurar headers para multipart/form-data
     */
    _getMultipartHeaders(token) {
        return {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        };
    }

    /**
     * Manejar errores de API
     */
    _handleError(error, defaultMessage) {
        if (error.response) {
            throw new Error(error.response.data.error || error.response.data.message || defaultMessage);
        } else if (error.request) {
            throw new Error('No se pudo conectar con el servidor');
        } else {
            throw new Error(error.message || defaultMessage);
        }
    }

    /**
     * Subir un PDF: la IA lo lee y la carga queda «por revisar». Puede tardar hasta 2 minutos.
     *
     * @param {Object} datos - { idCompany, anioComercial, archivo }
     * @param {string} token - Token de autenticación
     * @returns {Promise<Object>} { data: carga con filas, filas_con_aviso y filas_con_error }
     */
    async subirPdf({ idCompany, anioComercial, archivo }, token) {
        try {
            const formData = new FormData();
            formData.append('archivo', archivo);
            formData.append('id_company', idCompany);
            formData.append('anio_comercial', anioComercial);
            const response = await axios.post(
                `${API_BASE_URL}/api/inversiones-exterior/pdf/cargas`,
                formData,
                { headers: this._getMultipartHeaders(token) }
            );
            return response.data;
        } catch (error) {
            this._handleError(error, 'Error al subir el PDF');
        }
    }

    /**
     * Datos del documento y su cuadratura contra las filas de la carga
     *
     * @param {string} idCarga - ID de la carga
     * @param {string} token - Token de autenticación
     * @returns {Promise<Object>} { tipo_documento, periodo, anio, moneda, anio_comercial, conceptos }
     */
    async getCuadratura(idCarga, token) {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/api/inversiones-exterior/pdf/cargas/${idCarga}/cuadratura`,
                { headers: this._getHeaders(token) }
            );
            return response.data.data;
        } catch (error) {
            this._handleError(error, 'Error al obtener la cuadratura');
        }
    }
}

const inversionesExteriorPdfService = new InversionesExteriorPdfService();
export default inversionesExteriorPdfService;
